import { render } from "./HomepageNav.vue?vue&type=template&id=1986437e"
import script from "./HomepageNav.vue?vue&type=script&lang=js"
export * from "./HomepageNav.vue?vue&type=script&lang=js"
script.render = render

export default script